import React, { useContext, useEffect } from 'react';
import { MapContext } from '../component';
import mapboxgl, { TerrainSpecification } from 'mapbox-gl';

export const Terrain = ({ options }: { options?: TerrainSpecification }) => {
  const map = useContext(MapContext);
  useEffect(() => {
    map.on('load', () => map.setTerrain(options));
  }, []);

  return null;
};
